import React, { Component } from "react";
import "../../App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Fade from "@material-ui/core/Fade";
import ViewTopBar from "../common_components/viewChanger";
import BottomBar from "../common_components/bottom_bar.component";
import { Link, Redirect } from "react-router-dom";
import Slider from "react-slick";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    flexGrow: 1,
    color: "black",
    marginTop: 10,
    fontWeight: "bold",
    fontFamily: "Open Sans",
  },
  slider_wrapper: {
    position: "relative",
    width: "100%",
    height: 470,
    marginTop: -50,
    objectFit: "cover",
  },
  slide: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    maxHeight: 700,
  },
  text_title: {
    fontSize: "3rem",
    "@media (min-width:200px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:600px)": {
      fontSize: "2rem",
    },
    "@media (min-width:960px)": {
      fontSize: "3rem",
    },
    marginTop: "18px",
  },
  card: {
    minWidth: 275,
    width: "24%",
    height: 450,
    minHeight: 400,
    borderWidth: 1,
    borderColor: "#F6277F",
    borderStyle: "solid",
    "@media (min-width:200px)": {
      height: 350,
    },
    "@media (min-width:600px)": {
      height: 400,
    },
    "@media (min-width:960px)": {
      height: 500,
    },
  },
  card_title: {
    fontSize: 24,
  },
  button: {
    backgroundColor: "#F6277F",
    color: "#FFF",
    height: 50,
    fontFamily: "Open Sans",
    fontSize: "14px",
    textTransform: "none",
    "&:hover": {
      //you want this to be the same as the backgroundColor above
      backgroundColor: "#c40859",
    },
  },
  image_size: {
    height: 200,
    marginBottom: 50,
    "@media (min-width:200px)": {
      height: 140,
      marginBottom: 20,
    },
    "@media (min-width:600px)": {
      height: 150,
      marginBottom: 30,
    },
    "@media (min-width:960px)": {
      height: 200,
      marginBottom: 50,
    },
  },
  card_text: {
    fontFamily: "Open Sans",
    fontSize: 18,
    "@media (min-width:200px)": {
      fontSize: 13,
    },
    "@media (min-width:600px)": {
      fontSize: 15,
    },
    "@media (min-width:960px)": {
      fontSize: 18,
    },
    marginLeft: 15,
    marginRight: 15,
  },
  small_image_size: {
    height: 70,
    "@media (min-width:200px)": {
      height: 40,
    },
    "@media (min-width:600px)": {
      height: 50,
    },
    "@media (min-width:960px)": {
      height: 70,
    },
  },
});
function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowLeftIcon
      style={{
        position: "absolute",
        top: "42.5%",
        color: "#F6277F",
        fontSize: 60,
        zIndex: "999",
        marginLeft: -24,
      }}
      onClick={onClick}
    />
  );
}

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowRightIcon
      className={className}
      style={{
        color: "#F6277F",
        fontSize: 60,
      }}
      onClick={onClick}
    />
  );
}

var settings = {
  dots: true,
  autoplay: true,
  autoplaySpeed: 5000,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  speed: 500,
  arrows: true,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
};

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
      right: false,
      image:
        "https://canawho-bucket.s3.ca-central-1.amazonaws.com/1597096885885_cw%20mobile%20website%20homepage%20image-min.png",
      currentIndex: 0,
      translateValue: 0,
      checkedOne: false,
      checkedTwo: false,
      checkedThree: false,
      ads: [1, 2, 3],
    };
  }

  componentDidMount() {
    document.title = "CanaWho";
  }

  Slide = ({ image }) => {
    const { classes } = this.props;
    const styles = {
      backgroundImage: `url(${image})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50% 60%",
    };
    return <div className={classes.slide} style={styles}></div>;
  };

  handleChange(check) {
    switch (check) {
      case 0:
        this.setState({ checkedOne: !this.state.checkedOne });
        break;
      case 1:
        this.setState({ checkedTwo: !this.state.checkedTwo });
        break;
      case 2:
        this.setState({ checkedThree: !this.state.checkedThree });
        break;
      default:
      // code block
    }
  }

  render() {
    const { classes } = this.props;
    const { checkedOne, checkedTwo, checkedThree, image, ads } = this.state;

    return (
      <div className={classes.root}>
        <ViewTopBar />
        <img src={image} alt="Banner" className={classes.slider_wrapper} />
        <h1 style={{ textAlign: "center" }} className={classes.text_title}>
          <u>Express Yourself</u>
        </h1>
        <Grid
          container
          spacing={0}
          alignContent="center"
          alignItems="center"
          justify="center"
          style={{
            maxWidth: "100vw",
            width: "90%",
            marginLeft: "5%",
            marginBottom: "10%",
          }}
        >
          <Slider {...settings} style={{ maxWidth: "100vw", width: "100%" }}>
            <Grid item align="center">
              <Card className={classes.card}>
                <CardContent>
                  <h1
                    style={{ textAlign: "center" }}
                    className={classes.card_title}
                  >
                    <u>Community</u>
                  </h1>
                  {checkedOne ? (
                    <Fade in={checkedOne}>
                      <Typography
                        align={"center"}
                        className={classes.card_text}
                      >
                        CanaWho’s community provides consumers, enthusiasts, and
                        brands a space to unite and communicate together.
                        Sharing your experiences is how we can create a
                        confident cannabis community.
                      </Typography>
                    </Fade>
                  ) : (
                    <Grid
                      container
                      spacing={0}
                      direction="column"
                      alignItems="center"
                      justify="center"
                    >
                      <img
                        alt=""
                        className={classes.image_size}
                        style={{ marginTop: 20 }}
                        src={
                          "https://canawho-bucket.s3.ca-central-1.amazonaws.com/1595341426344_globe.PNG"
                        }
                      />
                    </Grid>
                  )}
                </CardContent>
                <CardActions style={{ justifyContent: "center" }}>
                  {checkedOne ? (
                    <Grid
                      container
                      spacing={0}
                      direction="column"
                      alignItems="center"
                      justify="center"
                    >
                      <Grid
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justify="center"
                      >
                        <img
                          alt=""
                          class={classes.small_image_size}
                          style={{ marginTop: 20 }}
                          src={
                            "https://canawho-bucket.s3.ca-central-1.amazonaws.com/1595341426344_globe.PNG"
                          }
                          onClick={() => this.handleChange(0)}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Button size="small" onClick={() => this.handleChange(0)}>
                      Tap Here To Learn
                    </Button>
                  )}
                </CardActions>
              </Card>
            </Grid>
            <Grid item align="center">
              <Card className={classes.card}>
                <CardContent>
                  <h1
                    style={{ textAlign: "center" }}
                    className={classes.card_title}
                  >
                    <u>Wanda</u>
                  </h1>
                  {checkedTwo ? (
                    <Fade in={checkedTwo}>
                      <Typography
                        align={"center"}
                        className={classes.card_text}
                      >
                        Wanda is CanaWho’s Virtual Cannabis Specialist(VCS).
                        Through convenient conversation and AI integration,
                        Wanda provides an alternative experience to better
                        understand cannabis and support
                        safe-cannabis-consumption.
                      </Typography>
                    </Fade>
                  ) : (
                    <Grid
                      container
                      spacing={0}
                      direction="column"
                      alignItems="center"
                      justify="center"
                    >
                      <img
                        alt=""
                        className={classes.image_size}
                        style={{ marginTop: 20 }}
                        src={
                          "https://canawho-bucket.s3.ca-central-1.amazonaws.com/1581540584639_logo.png"
                        }
                      />
                    </Grid>
                  )}
                </CardContent>
                <CardActions style={{ justifyContent: "center" }}>
                  {checkedTwo ? (
                    <Grid
                      container
                      spacing={0}
                      direction="column"
                      alignItems="center"
                      justify="center"
                    >
                      <Grid
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justify="center"
                      >
                        <img
                          alt=""
                          className={classes.small_image_size}
                          style={{ marginTop: 20 }}
                          src={
                            "https://canawho-bucket.s3.ca-central-1.amazonaws.com/1581540584639_logo.png"
                          }
                          onClick={() => this.handleChange(1)}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Button size="small" onClick={() => this.handleChange(1)}>
                      Tap Here To Learn
                    </Button>
                  )}
                </CardActions>
              </Card>
            </Grid>
            <Grid item align="center">
              <Card className={classes.card}>
                <CardContent>
                  <h1
                    style={{ textAlign: "center" }}
                    className={classes.card_title}
                  >
                    <u>Explore</u>
                  </h1>
                  {checkedThree ? (
                    <Fade in={checkedThree}>
                      <Typography
                        align={"center"}
                        className={classes.card_text}
                      >
                        Explore the Legal Canadian cannabis market, discover
                        newly regulated products and learn how they may suit
                        your specific needs. The variety of products supports
                        the needs of each individual consumer.
                      </Typography>
                    </Fade>
                  ) : (
                    <Grid
                      container
                      spacing={0}
                      direction="column"
                      alignItems="center"
                      justify="center"
                    >
                      <img
                        alt=""
                        className={classes.image_size}
                        style={{ marginTop: 20 }}
                        src={
                          "https://canawho-bucket.s3.ca-central-1.amazonaws.com/1597096600135_Explore%20Icon%20sz.15%20.png"
                        }
                      />
                    </Grid>
                  )}
                </CardContent>
                <CardActions style={{ justifyContent: "center" }}>
                  {checkedThree ? (
                    <Grid
                      container
                      spacing={0}
                      direction="column"
                      alignItems="center"
                      justify="center"
                    >
                      <Grid
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justify="center"
                      >
                        <img
                          alt=""
                          className={classes.small_image_size}
                          style={{ marginTop: 20 }}
                          src={
                            "https://canawho-bucket.s3.ca-central-1.amazonaws.com/1597096600135_Explore%20Icon%20sz.15%20.png"
                          }
                          onClick={() => this.handleChange(2)}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Button size="small" onClick={() => this.handleChange(2)}>
                      Tap Here To Learn
                    </Button>
                  )}
                </CardActions>
              </Card>
            </Grid>
          </Slider>
        </Grid>
        <Grid
          container
          justify="center"
          style={{ paddingTop: "2%", marginBottom: "100px" }}
        >
          <Button
            component={Link}
            to="/join"
            variant="contained"
            size="large"
            className={classes.button}
          >
            Join Our Company Community Today!
          </Button>
        </Grid>
        <BottomBar />
      </div>
    );
  }
}

HomePage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HomePage);
